import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FlowTypes } from '../../../common/models/order/order.model';
import { COMMON_FLOW } from './common.flow';
import { FlowContext, FlowDefinition, FlowStepData, FlowStep, StepTarget } from './flow.types';
import { INTERNET_FLOW } from './internet.flow';
import { VIDEO_FLOW } from './video.flow';
import { VOICE_FLOW } from './voice.flow';
import { WIRELESS_FLOW } from './wireless.flow';
import { OrderRoutes } from '../orders-routes.enum';

@Injectable({ providedIn: 'root' })
// Service that provides navigation for order flows.
export class OrderFlowNavigationService {
    private readonly router = inject(Router);

    private readonly flows: Record<string, FlowDefinition> = {
        [FlowTypes.INTERNET]: INTERNET_FLOW,
        [FlowTypes.VIDEO]: VIDEO_FLOW,
        [FlowTypes.VOICE]: VOICE_FLOW,
        [FlowTypes.WIRELESS]: WIRELESS_FLOW
    };

    getNextRoute(ctx: FlowContext, data?: FlowStepData): string | null {
        const route = this.getRoute(ctx, data, 'next');
        return route === OrderRoutes.CREDIT_CHECK && ctx.canReuseQualifiedSelections()
            ? ctx.determineNextRouteInFlow()
            : route;
    }

    getBackRoute(ctx: FlowContext, data?: FlowStepData): string | null {
        return this.getRoute(ctx, data, 'back');
    }

    private getRoute(ctx: FlowContext, data: FlowStepData | undefined, direction: 'next' | 'back'): string | null {
        const target = this.findStep(ctx)?.[direction];
        if (!target) {
            return null;
        }
        return this.toRoute(target, ctx, data);
    }

    private toRoute(target: StepTarget, ctx: FlowContext, data?: FlowStepData): string | null {
        return typeof target === 'function' ? target(ctx, data) : target;
    }

    private findStep(ctx: FlowContext): FlowStep | undefined {
        const route = this.router.url.split('?')[0];
        const flow = ctx.currentFlow();
        const flowDefinition = flow ? this.flows[flow] : undefined;
        return flowDefinition?.find(step => step.route === route)
            ?? COMMON_FLOW.find(step => step.route === route);
    }
}
